import React, {useEffect} from 'react'
import Aos from 'aos';
import "aos/dist/aos.css";
import { BallTwistPen } from '../../../Shared/Images/image';

const Statements = props =>{
    useEffect(()=>{
        Aos.init({duration: 3000})
    }, [])  
     return(
        <section>
            <div className="mx-width">
                <div className="px-5 py-5">
                    <div className="row align-items-center">
                        <div className="col-lg-6" data-aos="fade-right">
                            <div>
                                <img className="img-fluid" src={ BallTwistPen } alt="blackTwistPen" />
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-left">
                            <div className="mb-3">
                                <h4 className="heading4 text-color1 mb-3">Our <span className="text-color2">Vision</span></h4>
                                <p className=" p2 fw-sb text-color1">Our vision is to develop confident and well-rounded students by helping them in securing admissions in top universities around the globe.</p>
                            </div>
                            <div className="mb-3">            
                                <h4 className="heading4 text-color1 mb-3">Our <span className="text-color2">Mission</span></h4>
                                <p className="p2 fw-sb text-color1">To become an outstanding and finest educational consulting firm with an international flair to facilitate students in seeking admission opportunities to study abroad.</p>
                            </div>
                            <div className="mb-3">            
                                <h4 className="heading4 text-color1 mb-3">Our <span className="text-color2">Values</span></h4>
                                <ul className="pl-4 values-list mb-0">
                                    <li>Integrity</li>
                                    <li>Resourcefulness</li>
                                    <li>Quality</li>
                                    <li>Determination</li>
                                </ul>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
     )
}

export default Statements;